export default {
  modals: state => state.modalsIds.map(id => state.modalsById[id]),
  getModal: state => id => state.modalsById[id],
  getModalPayload: (_, getters) => id => {
    const modal = getters.getModal(id);
    return modal.payload ?? {};
  }
};
